import React, { useState, useEffect, useContext, useRef   } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/TopUp.css';
import useForm from "../../../services/UseForm";
import validate from '../../../validations/admin/member/coffeeValidate';
import axios from "axios";
import { API } from "../../../services/api";
import { UserContext, AlertContext } from "../../../App";
import { useReactToPrint } from 'react-to-print';
import '../../../css/MemberBill.css';
import exiticon from '../../../img/icon/mainMenu/exit.png';
import Alert from "../../../components/alert";


axios.defaults.baseURL = API;

function BuyCoffee() {

    function getDate() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        return `${year}-${month}-${date} ${time}`;
    }
  const {showAlert, setShowAlert, errorMessage, setErrorMessage} = useContext(AlertContext);
  const componentRef = useRef();
  const {userID, UserName, LocationID, LocationName, showForm, setShowForm, setshowSubmenu, Address, Tell, device, setDevice, status, setStatus, EPSON_VENDOR_ID} = useContext(UserContext);
 
  const [PaymentTypeList, setPaymentTypeList] = useState([]);
  const [PaymentTypeID, setPaymentTypeID] = useState(0);
  const [BillNO, setBillNO] = useState("");
  const [PrintCount, setPrintCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [VarityList, setVarityList] = useState([]);
  const [FarmList, setFarmList] = useState([]);
  const [TypeList, setTypeList] = useState([]);


    const handleInputPrintCount = event => { 
        const { name, value } = event.target;
        setPrintCount(value)
    };

  function currencyFormat(num) {
    if (num > 0) 
        return Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return 0
  }



    const connectPrinter = async () => {
        try {
            setStatus('Connecting...');
            
            // Request permission to access the USB device
            const selectedDevice = await navigator.usb.requestDevice({
                filters: [{ vendorId: EPSON_VENDOR_ID }]
            });

            await selectedDevice.open();
            
            // Select configuration (most USB printers use configuration 1)
            if (selectedDevice.configuration === null) {
                await selectedDevice.selectConfiguration(1);
            }
            
            // Claim the primary interface (usually interface 0)
            await selectedDevice.claimInterface(0);

            setDevice(selectedDevice);
            setStatus(`Connected to: ${selectedDevice.productName || 'Epson Printer'}`);
            } catch (error) {
                console.error('USB Connection Error:', error);
                setStatus(`Connection failed: ${error.message}`);
            }
    };

    let receipt = '';
    const ESC = '\x1B';
    const GS = '\x1D';
    const CMD = {
        INIT: ESC + '@',             // Initialize printer
        ALIGN_LEFT: ESC + 'a\x00',   // Left alignment
        ALIGN_CENTER: ESC + 'a\x01', // Center alignment
        ALIGN_RIGHT: ESC + 'a\x02',  // Right alignment
        FONT_NORMAL: ESC + '!', // Select normal font (Font A)
        FONT_Size: ESC + '!' + 1,     
        FONT_SizeNomal: ESC + '!' + 0,    
        FONT_BOLD: ESC + 'E\x01',    // Turn on bold
        FONT_REGULAR: ESC + 'E\x00', // Turn off bold
        FEED_CUT: GS + 'V\x41\x03',  // Feed paper and cut (Partial cut)
    };

  // Utility to pad out text to exactly 42 characters for flawless right alignment
    const formatLeftRight = (leftText, rightText, maxChars = 48) => {
        const spacesNeeded = maxChars - (leftText.length + rightText.length);
        if (spacesNeeded <= 0) {
        return leftText.substring(0, maxChars - rightText.length - 1) + ' ' + rightText + '\n';
        }
        return leftText + ' '.repeat(spacesNeeded) + rightText + '\n';
    };

    const PrintBillDetail = (gTransactionID) => {
        setLoading(true);
        let receipt = '';

        // 1. Initialize Printer
        receipt += CMD.INIT;

        // 2. Header Section (Centered)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Manee Coffee Roasters'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += '-'.repeat(48) + '\n'; // Divider

        // 3. Metadata Section (Left Aligned)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + `Bill`.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += CMD.ALIGN_LEFT;
        receipt += `BILL ID# ${gTransactionID}\n`;
        receipt += `Date: ${new Date().toLocaleDateString()}\n`;
        receipt += `Employee: ${UserName}\n`;
        receipt += '-'.repeat(48) + '\n';
        // 5. Totals Section
        receipt += formatLeftRight("Farm:", `${values.Farm}`);
        receipt += formatLeftRight("Type:", `${values.Type}`);
        receipt += formatLeftRight("Varity:", `${values.Varity}`);
        receipt += formatLeftRight("Quantity:", `${currencyFormat(values.Quantity)}`);
        receipt += formatLeftRight("Price:", `${currencyFormat(values.Price)}`);
        receipt += '='.repeat(48) + '\n';
        // Bold total row
        receipt += CMD.FONT_BOLD;
        receipt += formatLeftRight("TOTAL:", `${currencyFormat(values.SubTotal)}`);
        receipt += CMD.FONT_REGULAR;
        receipt += '='.repeat(48) + '\n';

        receipt += formatLeftRight("PaymentType:", `${values.PaymentType}`);
        receipt += formatLeftRight("PaidAmount:", `${currencyFormat(values.SubTotal)}`);
    

        receipt += '='.repeat(48) + '\n';

        // 6. Footer & Auto-Cut
        receipt += CMD.ALIGN_CENTER;
        receipt += "Thank you for your visit!\n";
        receipt += "Please come again\n\n\n\n"; // Feeds space before cutting
        receipt += CMD.FEED_CUT;

        // Convert string to Uint8Array for binary transmission
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(receipt);
        
        setLoading(false);
        return uint8Array;
    };

  const handlePrintBill = async (gTransactionID) => {
    if(device){
        const endpointOut = device.configuration.interfaces[0].alternate.endpoints.find(
            (ep) => ep.direction === 'out' && ep.type === 'bulk'
        );
        const endpointNumber = endpointOut.endpointNumber;
        const rawBuffer = PrintBillDetail(gTransactionID);
        await device.transferOut(endpointNumber, rawBuffer);
    } else {
        connectPrinter();
    }
    
    // Example hook for connecting to WebUSB or Bluetooth native API
    // await sendToPrinter(rawBuffer);
  };
 
  
  const handleSelectFarm = (e) => {
        var data = FarmList.filter(function (item) {
            return item.Farm == e.target.value
        })
        if (data.length > 0) {
            handleChange("Farm", data[0].Farm);
            handleChange("FarmID", data[0].FarmID);
        } else {
            handleChange("Farm", "");
            handleChange("FarmID", "");
        }
    };


    async function getAllFarm() {
        axios
        .get("/getAllFarm")
        .then((response) => {
            let Data = response?.data;
            setFarmList(Data);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    async function getAllType() {
    axios
      .get("/getAllType")
      .then((response) => {
        let Data = response?.data;
        setTypeList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleSelectVarity = (e) => {
        var data = VarityList.filter(function (item) {
            return item.Varity == e.target.value
        })
        if (data.length > 0) {
            handleChange("Varity", data[0].Varity);
            handleChange("VarityID", data[0].VarityID);
        } else {
            handleChange("Varity", "");
            handleChange("VarityID", "");
        }
    };

    async function getVarityByTypeID(value) {
        let token = localStorage.getItem("token");
        await axios.get(`/getAllVarityByTypeID/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
          let temOrder = response?.data;
          if(temOrder.length > 0){
            setVarityList(temOrder);
          } else {
            setVarityList([]);
          }
        }).catch((err) => {
            setVarityList([]);
            console.log(err);
        });
    }

    const handleSelectType = (e) => {
        const { value } = e.target;
        if(value){
            console.log(e.target.children[e.target.selectedIndex].getAttribute('data-id'));
            getVarityByTypeID(e.target.children[e.target.selectedIndex].getAttribute('data-id'));
            handleChange("Type", value);
            handleChange("TypeID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("Type", "");
            handleChange("TypeID", "");
            handleChange("Varity", "");
            handleChange("VarityID", "");
        }
        
    };


  const handleQuantity = (e) => {
    const { name, value } = e.target;
      if (value) {
              handleChange(name, value);
      } else {
          handleChange(name, 0);
      }
  }

  const handlePrice = event => {
    const { name, value } = event.target;
      const re = /^[0-9\b]+$/;
      if (value) {
        console.log(values.Quantity, value);
          if (value === '' || re.test(value.split(',').join(''))) {
              handleChange(name, value.split(',').join(''));
              const total = Number(value.split(',').join('')) * Number(values.Quantity);
              handleChange("Subtotal", total);
          }  
      } else {
          handleChange(name, value);
      }
  }

  const handleSelectPaymentType = (e) => {
    var data = PaymentTypeList.filter(function (item) {
        return item.PaymentType === e.target.value
    })
    if (data.length > 0) {
        setPaymentTypeID(data[0].PaymentTypeID);
        handleChange("PaymentType", data[0].PaymentType);
        handleChange("PaymentTypeID", data[0].PaymentTypeID);
    } else {
        handleChange("PaymentType", "");
        handleChange("PaymentTypeID", "");
    }
};

async function saveTutorial() {
    let token = localStorage.getItem("token");
    var data = {
        VarityID: values.VarityID,
        TypeID: values.TypeID,
        Price: values.Price,
        Quantity: values.Quantity,
        FarmID: values.FarmID,
        SubTotal: values.Subtotal,
        PaymentTypeID: PaymentTypeID,
        CreatedDate: getDate(),
        StatusID: 1,
    }
    await axios.post("/CreateBuyCoffee", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        // PrintPaymentBill(response?.data?.insertId);
        handlePrintBill(response?.data?.insertId);
        ClearData();
    }).catch((err) => {
        console.log(err);
    });
};


const ClearData = () => {
    handleChange("VarityID", "");
    handleChange("TypeID", "");
    handleChange("Price", "");
    handleChange("Quantity", "");
    handleChange("FarmID", "");
    handleChange("SubTotal", "0" );
}

const handleclickBack = () => {
    setShowForm(false);
    setshowSubmenu(true);
};


const {
    values,
    errors,
    handleChange,
    handleSubmit,
  } = useForm(saveTutorial, validate);

  useEffect(() => {
    let paymentData = localStorage.getItem("paymentTypeData");
    if (paymentData) {
      let userRole = JSON.parse(paymentData);
      setPaymentTypeList(userRole);
    }
    getAllFarm();
    getAllType();

  }, []);

  return (
    <div className="TopUpMemberFormContent">
         <Alert/> 
        <form onSubmit={handleSubmit} noValidate className="topupform">
            <div className="leftContent">
                <div className="leftHeader">
                    <div className="topupleftTitle">
                        <span>ຮັບຊື້ເມັດກາເຟໝາກແດງ</span>
                    </div>
                </div>
                <div className="leftBody">
                    <div className="topupitem">
                        <div className="cbPaymentType">
                            <label>ສວນ: </label>
                            <select name="FarmID" onChange={(e) => handleSelectFarm(e)}
                                className={`input form-control ${errors.FarmID && 'is-invalid'}`}>
                                <option
                                    key={""}
                                    value={""}
                                >
                                    {'ເລືອກສວນ'}
                                </option>
                                {   FarmList && FarmList.map(item => (
                                    <option
                                        key={item.FarmID}
                                        data-id={item.FarmID}
                                        value={item.Farm}
                                    >
                                        {item.Farm}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="cbPaymentType">
                            <label>ປະເພດ: </label>
                            <select name="TypeID" onChange={(e) => handleSelectType(e)}
                                className={`input form-control ${errors.TypeID && 'is-invalid'}`}>
                                <option
                                    key={""}
                                    value={""}
                                >
                                    {'ເລີອກປະເພດ'}
                                </option>
                                {   TypeList && TypeList.map(item => (
                                    <option
                                        key={item.TypeID}
                                        data-id={item.TypeID}
                                        value={item.Type}
                                    >
                                        {item.Type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="cbPaymentType">
                            <label>ສາຍພັນ: </label>
                            <select name="VarityID" onChange={(e) => handleSelectVarity(e)}
                                className={`input form-control ${errors.VarityID && 'is-invalid'}`}>
                                <option
                                    key={""}
                                    value={""}
                                >
                                    {'ເລືອກສາຍພັນ'}
                                </option>
                                {   VarityList && VarityList.map(item => (
                                    <option
                                        key={item.VarityID}
                                        value={item.Varity}
                                    >
                                        {item.Varity}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="txtTopUpAmount">
                            <span>ນ້ຳໜັກ</span>
                            <input className={`input form-control ${errors.Quantity && 'is-invalid'}`}   name="Quantity" onChange={(e) => handleQuantity(e)} value={(values.Quantity) || ''} required />
                            {errors.Quantity && (
                            <p className="invalid-feedback">{errors.Quantity}</p>
                            )}
                        </div>
                        <div className="txtPaidAmount">
                            <span>ລາຄາ</span>
                            <input className={`input form-control ${errors.Price && 'is-invalid'}`} type="text" name="Price" onChange={(e) => handlePrice(e)} value={(values.Price) || ''} required disabled={!values.Quantity} />
                            {errors.Price && (
                            <p className="invalid-feedback">{errors.Price}</p>
                            )}
                        </div>
                        <div className="cbPaymentType">
                            <label>ປະເພດຈ່າຍ: </label>
                            <select name="PaymentTypeID" onChange={(e) => handleSelectPaymentType(e)}
                                className={`input form-control ${errors.PaymentTypeID && 'is-invalid'}`}>
                                <option
                                    key={""}
                                    value={""}
                                >
                                    {'ເລືອກປະເພດຈ່າຍ'}
                                </option>
                                {   PaymentTypeList && PaymentTypeList.map(item => (
                                    <option
                                        key={item.PaymentTypeID}
                                        value={item.PaymentType}
                                    >
                                        {item.PaymentType}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rightContent">
                <div className="header">
                        <span className="text">ຂໍ້ມູນຮັບຊື້ເມັດກາເຟ</span>
                    </div>
                <div className="rightBody">
                    
                    <div className="gMemberNo">
                        <span >ສວນ:</span>
                        <span >{values.Farm}</span>
                    </div>
                    
                    <div className="gPreviousAmout">
                        <span >ປະເພດເມັດ:</span>
                        <span>{values.Type}</span>
                    </div>
                    
                    <div className="gTopupAmout">
                        <span >ສາຍພັນ:</span>
                        <span>{values.Varity}</span>
                    </div>

                    <div className="gTopupAmout">
                        <span >ຈຳນວນ:</span>
                        <span>{currencyFormat(values.Quantity)}</span>
                    </div>
                    <div className="gTopupAmout">
                        <span >ລາຄາ:</span>
                        <span>{currencyFormat(values.Price)}</span>
                    </div>
                    
                    <div className="gSubtotal">
                        <span >ຍອດລວມ:</span>
                        <span >{currencyFormat(values.Subtotal)}</span>
                    </div>
                    
                    <div className="header2">
                        <span>ຂໍ້ມູນການຈ່າຍ</span>
                    </div>
                    <div className="gPaidAmout">
                        <span>ປະເພດຈ່າຍ:</span>
                        <strong>{(values.PaymentType)}</strong>
                    </div>
                    <div className="gPaidAmout">
                        <span>ຍອດຈ່າຍ:</span>
                        <strong>{currencyFormat(values.Subtotal)}</strong>
                    </div>
                       
                    <div className="rightFooter">
                        <button type="submit" className="btn btn-primary btnPayment" >ຈ່າຍເງິນ</button>
                        <button type="button" className="btn btn-primary btnBack" onClick={() => connectPrinter()} >Connect</button>
                        <button className="btn btn-danger btnBack" onClick={() => handleclickBack()} >Back</button>
                        <div className="headerPrintcount">
                            <span>ຈຳນວນບິນ:</span>
                            <input className="PrintCount" type="text" name="PrintCount" placeholder="1" onChange={(e) => handleInputPrintCount(e)} value={PrintCount} required />
                        </div>
                    
                    </div>
                    
                </div>
            </div>
        </form>
      </div>
  );
};

export default BuyCoffee;
